export default "/images/slickslide-4.jpg?0cc857f7634747a936e61216316f4f19";